export const courseConstants = {
    ADD_COURSE_REQUEST: 'ADD_COURSE_REQUEST',
    ADD_COURSE_SUCCESS: 'ADD_COURSE_SUCCESS',
    ADD_COURSE_FAILURE: 'ADD_COURSE_FAILURE',

    GET_COURSE_REQUEST: 'GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'GET_COURSE_SUCCESS',
    GET_COURSE_FAILURE: 'GET_COURSE_FAILURE',

    DELETE_COURSE_REQUEST: 'DELETE_COURSE_REQUEST',
    DELETE_COURSE_SUCCESS: 'DELETE_COURSE_SUCCESS',
    DELETE_COURSE_FAILURE: 'DELETE_COURSE_FAILURE',


    GET_COURSES_REQUEST: 'GET_COURSES_REQUEST',
    GET_COURSES_SUCCESS: 'GET_COURSES_SUCCESS',
    GET_COURSES_FAILURE: 'GET_COURSES_FAILURE',


    TOGGLE_COURSE_STATUS_REQUEST: 'TOGGLE_COURSE_STATUS_REQUEST',
    TOGGLE_COURSE_STATUS_SUCCESS: 'TOGGLE_COURSE_STATUS_SUCCESS',
    TOGGLE_COURSE_STATUS_FAILURE: 'TOGGLE_COURSE_STATUS_FAILURE',

    CHANGE_COURSE_NAME_REQUEST: 'CHANGE_COURSE_NAME_REQUEST',
    CHANGE_COURSE_NAME_SUCCESS: 'CHANGE_COURSE_NAME_SUCCESS',
    CHANGE_COURSE_NAME_FAILURE: 'CHANGE_COURSE_NAME_FAILURE',

    CHANGE_COURSE_DISPLAY_NAME_REQUEST: 'CHANGE_COURSE_DISPLAY_NAME_REQUEST',
    CHANGE_COURSE_DISPLAY_NAME_SUCCESS: 'CHANGE_COURSE_DISPLAY_NAME_SUCCESS',
    CHANGE_COURSE_DISPLAY_NAME_FAILURE: 'CHANGE_COURSE_DISPLAY_NAME_FAILURE',

    
    GET_COURSE_SUBCOURSES_REQUEST: 'GET_COURSE_SUBCOURSES_REQUEST',
    GET_COURSE_SUBCOURSES_SUCCESS: 'GET_COURSE_SUBCOURSES_SUCCESS',
    GET_COURSE_SUBCOURSES_FAILURE: 'GET_COURSE_SUBCOURSES_FAILURE',


    CREATE_SUBCOURSE_REQUEST: 'CREATE_SUBCOURSE_REQUEST',
    CREATE_SUBCOURSE_SUCCESS: 'CREATE_SUBCOURSE_SUCCESS',
    CREATE_SUBCOURSE_FAILURE: 'CREATE_SUBCOURSE_FAILURE',

    UPDATE_INDEX_SUBCOURSE_REQUEST : 'UPDATE_INDEX_SUBCOURSE_REQUEST',
    UPDATE_INDEX_SUBCOURSE_FAILED : 'UPDATE_INDEX_SUBCOURSE_FAILED',
    UPDATE_INDEX_SUBCOURSE_SUCCESS : 'UPDATE_INDEX_SUBCOURSE_SUCCESS',

    CREATE_SECTION_REQUEST: 'CREATE_SECTION_REQUEST',
    CREATE_SECTION_SUCCESS: 'CREATE_SECTION_SUCCESS',
    CREATE_SECTION_FAILURE: 'CREATE_SECTION_FAILURE',

    TOGGLE_SUBCOURSE_STATUS_REQUEST : 'TOGGLE_SUBCOURSE_STATUS_REQUEST',
    TOGGLE_SUBCOURSE_STATUS_SUCCESS : 'TOGGLE_SUBCOURSE_STATUS_SUCCESS',
    TOGGLE_SUBCOURSE_STATUS_FAILURE : 'TOGGLE_SUBCOURSE_STATUS_FAILURE',


    //get lesson
    GET_SECTION_REQUEST: 'GET_SECTION_REQUEST',
    GET_SECTION_SUCCESS: 'GET_SECTION_SUCCESS',
    GET_SECTION_FAILURE: 'GET_SECTION_FAILURE',


    //lessons
    CREATE_LESSON_REQUEST: 'CREATE_LESSON_REQUEST',
    CREATE_LESSON_SUCCESS: 'CREATE_LESSON_SUCCESS',
    CREATE_LESSON_FAILURE: 'CREATE_LESSON_FAILURE',

    GET_LESSON_REQUEST: 'GET_LESSON_REQUEST',
    GET_LESSON_SUCCESS: 'GET_LESSON_SUCCESS',
    GET_LESSON_FAILURE: 'GET_LESSON_FAILURE',


    UPDATE_INDEX_SECTION_REQUEST : 'UPDATE_INDEX_SECTION_REQUEST',
    UPDATE_INDEX_SECTION_FAILED : 'UPDATE_INDEX_SECTION_FAILED',
    UPDATE_INDEX_SECTION_SUCCESS : 'UPDATE_INDEX_SECTION_SUCCESS',



    UPDATE_INDEX_LESSON_REQUEST : 'UPDATE_INDEX_LESSON_REQUEST',
    UPDATE_INDEX_LESSON_FAILED : 'UPDATE_INDEX_LESSON_FAILED',
    UPDATE_INDEX_LESSON_SUCCESS : 'UPDATE_INDEX_LESSON_SUCCESS',


    DELETE_SUBCOURSE_REQUEST: 'DELETE_SUBCOURSE_REQUEST',
    DELETE_SUBCOURSE_SUCCESS: 'DELETE_SUBCOURSE_SUCCESS',
    DELETE_SUBCOURSE_FAILURE: 'DELETE_SUBCOURSE_FAILURE',

    
    DELETE_SECTION_REQUEST: 'DELETE_SECTION_REQUEST',
    DELETE_SECTION_SUCCESS: 'DELETE_SECTION_SUCCESS',
    DELETE_SECTION_FAILURE: 'DELETE_SECTION_FAILURE',
    
    DELETE_LESSON_REQUEST: 'DELETE_LESSON_REQUEST',
    DELETE_LESSON_SUCCESS: 'DELETE_LESSON_SUCCESS',
    DELETE_LESSON_FAILURE: 'DELETE_LESSON_FAILURE',


    TOGGLE_SECTION_STATUS_REQUEST: 'TOGGLE_SECTION_STATUS_REQUEST',
    TOGGLE_SECTION_STATUS_SUCCESS: 'TOGGLE_SECTION_STATUS_SUCCESS',
    TOGGLE_SECTION_STATUS_FAILURE: 'TOGGLE_SECTION_STATUS_FAILURE',

    TOGGLE_LESSON_STATUS_REQUEST: 'TOGGLE_LESSON_STATUS_REQUEST',
    TOGGLE_LESSON_STATUS_SUCCESS: 'TOGGLE_LESSON_STATUS_SUCCESS',
    TOGGLE_LESSON_STATUS_FAILURE: 'TOGGLE_LESSON_STATUS_FAILURE',

    SET_NODE_REQUEST: 'SET_NODE_REQUEST',
    SET_NODE_SUCCESS: 'SET_NODE_SUCCESS',
    SET_NODE_FAILURE: 'SET_NODE_FAILURE',



}


// WEBPACK FOOTER //
// ./src/redux/constants/courses.js